// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\np[data-v-485424ce] {\n  padding: 30px;\n  position: fixed;\n  top: 25%;\n  color: #bf616a;\n}\nform[data-v-485424ce] {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  margin-bottom: 2em;\n}\ngl-input[data-v-485424ce] {\n  width: 350px;\n  padding: 8px;\n}\ngl-button[data-v-485424ce] {\n  margin-top: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
